import { h, Component, Fragment } from "preact";
import {FiltersRow, InputFilter, SelectRow} from "../utils/table-utils";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import {DateHelperFilter} from "../utils/form-utils";
import PrematchFeedService from "../../../services/prematch-feed";
import OddsPrint from "../../../services/oddsprint";
import {route} from "preact-router";

const printOrdinalNumber = n => n+{e:"st",o:"nd",w:"rd",h:"th"}[new Intl.PluralRules("en",{type:"ordinal"}).select(n)[2]];

/**
 * Questa è la stampaquote copiata e incollata da un altro template. Devo buttare il JSX qui dentro e uniformarlo al resto.
 * Non ho tempo e voglia. Non ci saranno altri componenti basati su questo, quindi sta bene così
*/
export default class PrintOdds extends Component {
    state = {
        dateFilter: {
            helperValue: 0,
            dateStartValue: null,
            dateEndValue: null
        },
        form: {
            sort: '1',
            ori: "L",
            logo: false
        },
        loading: {
            tournaments: false,
            outcomes: false
        },

        sportnames: {},
        schedules: {},
        tournaments: {},
        outcomes: {},

        categoryselection: {},
        tournamentselection: {},
        outcomeselection: []
    };

    componentWillMount() {
        this.state.dateFilter.helperValue = 1; // Oggi
        this.state.dateFilter.dateStartValue = new Date().toLocaleDateString('en-CA');
        this.state.dateFilter.dateEndValue = this.state.dateFilter.dateStartValue;

        PrematchFeedService.getMenu((type,data) => {
            this.state.schedules = data;
            this.state.sportnames = Object.values(data).reduce((carry,sport) => {
                carry[sport._id] = sport.name;
                return carry;
            }, {});
            this.setState(this.state);
        });
    }

    performTournamentSearch() {
        this.state.tournaments = {};
        this.state.loading.tournaments = true;
        this.setState(this.state);

        const input = Object.entries(this.state.categoryselection).reduce((carry, [sport, categories]) => {
            carry[sport] = [JSON.stringify(categories)];
            return carry;
        }, {});

        OddsPrint.getTournamentsFromSelection(input)
            .then(data => {
                this.state.tournaments = data;
                this.state.outcomes = {};
                this.state.tournamentselection = {};
                this.state.outcomeselection = [];
                this.state.loading.tournaments = false;
                this.setState(this.state);
            })
            .catch(e => {
                this.state.outcomes = {};
                this.state.tournamentselection = {};
                this.state.outcomeselection = [];
                this.state.loading.tournaments = false;
                this.setState(this.state);
            });
    }

    performOutcomeSearch() {
        this.state.loading.outcomes = true;
        this.setState(this.state);

        OddsPrint.getOutcomesFromTournaments(this.state.tournamentselection)
            .then(data => {
                this.state.outcomes = data;
                this.state.outcomeselection = [];
                this.state.loading.outcomes = false;
                this.setState(this.state);
            });
    }

    performPDF() {
        if (!this.state.outcomeselection.length) {
            alert(window.Translation(msg`Devi selezionare almeno una tipologia di scommessa da stampare!`));
            return;
        }

        OddsPrint.getPDF(
            this.state.form.sort,
            this.state.form.ori,
            this.state.form.logo? '1' : '',
            this.state.dateFilter.dateStartValue,
            this.state.dateFilter.dateEndValue,
            this.state.tournamentselection,
            this.state.outcomeselection
        ).then(pdf => {
            window.open(pdf, 'pdf-page');
        });
    }

    sportSelectionToggle(sportid) {
        if (!!this.state.categoryselection[sportid]) {
            delete this.state.categoryselection[sportid];

            if (!Object.values(this.state.categoryselection).length) {
                this.state.tournaments = {};
            }

            this.setState(this.state);
            return;
        }

        new Promise(resolve => {
            const values = Object.values(this.state.schedules).filter(s => s._id === sportid);
            let countleft = values.length;

            values.map(
                sport => {
                    if (!this.state.categoryselection[sport._id]) {
                        this.state.categoryselection[sport._id] = [];
                    }

                    Object.values(sport.sub).map(
                        category => this.state.categoryselection[sport._id].push(category._id)
                    );

                    if (--countleft === 0) {
                        resolve();
                    }
                }
            );
        }).then(() => {

            this.setState(this.state);
            this.performTournamentSearch();

        });
    }

    categorySelectionToggle(sportid, categoryid) {
        if (!this.state.categoryselection[sportid]) {
            this.state.categoryselection[sportid] = [];
        }

        if (this.state.categoryselection[sportid].indexOf(categoryid) === -1) {
            this.state.categoryselection[sportid].push(categoryid);
        } else {
            this.state.categoryselection[sportid] = this.state.categoryselection[sportid].filter(c => c !== categoryid);

            if (!Object.values(this.state.categoryselection[sportid]).length) {
                delete this.state.categoryselection[sportid];

                if (!Object.values(this.state.categoryselection).length) {
                    this.state.tournaments = {};
                    console.info(this.state.tournaments);
                }
            }
        }

        this.setState(this.state);
        this.performTournamentSearch();
    }

    tournamentAllToggle() {
        if (!!Object.values(this.state.tournamentselection).length) {
            this.state.tournamentselection = {};

            if (!Object.values(this.state.tournamentselection).length) {
                this.state.outcomes = {};
            }

            this.setState(this.state);
            return;
        }

        new Promise(resolve => {
            Object.entries(this.state.tournaments).map(
                ([sportid, categories]) => Object.entries(categories).map(
                    ([categoryname, tournaments]) => {
                        tournaments.map(
                            tournament => {
                                if (!this.state.tournamentselection[sportid]) {
                                    this.state.tournamentselection[sportid] = {};
                                }

                                if (!this.state.tournamentselection[sportid][tournament.pal]) {
                                    this.state.tournamentselection[sportid][tournament.pal] = [];
                                }

                                this.state.tournamentselection[sportid][tournament.pal].push(tournament.num);
                            }
                        )
                    }
                )
            );

            resolve();
        }).then(() => {
            this.setState(this.state);
            this.performOutcomeSearch();
        });
    }

    tournamentParentToggle(sportid, categoryid, categoryname) {
        if (!!this.state.tournamentselection[sportid] && !!this.state.tournamentselection[sportid][categoryid]) {
            delete this.state.tournamentselection[sportid][categoryid];

            if (!Object.values(this.state.tournamentselection[sportid]).length) {
                delete this.state.tournamentselection[sportid];
            }

            if (!Object.values(this.state.tournamentselection).length) {
                this.state.outcomes = {};
            }

            this.setState(this.state);
            return;
        }

        if (!this.state.tournamentselection[sportid]) {
            this.state.tournamentselection[sportid] = {};
        }

        if (!this.state.tournamentselection[sportid][categoryid]) {
            this.state.tournamentselection[sportid][categoryid] = [];
        }

        new Promise(resolve => {
            const values = this.state.tournaments[sportid][categoryname];
            let countleft = values.length;

            values.map(
                tournament => {
                    this.state.tournamentselection[sportid][categoryid].push(tournament.num);

                    if (--countleft === 0) {
                        resolve();
                    }
                }
            );
        }).then(() => {
            this.setState(this.state);
            this.performOutcomeSearch();
        });
    }

    tournamentSelectionToggle(sportid, categoryid, tournamentid) {
        if (
            !!this.state.tournamentselection[sportid]
            && !!this.state.tournamentselection[sportid][categoryid]
            && this.state.tournamentselection[sportid][categoryid].indexOf(tournamentid) !== -1
        ) {
            this.state.tournamentselection[sportid][categoryid] = this.state.tournamentselection[sportid][categoryid]
                .filter(tid => tid !== tournamentid);

            if (this.state.tournamentselection[sportid][categoryid].length === 0) {
                delete this.state.tournamentselection[sportid][categoryid];
            }

            if (!Object.values(this.state.tournamentselection[sportid]).length) {
                delete this.state.tournamentselection[sportid];
            }

            if (!Object.values(this.state.tournamentselection).length) {
                this.state.outcomes = {};
            }

            this.setState(this.state);
            return;
        }

        if (!this.state.tournamentselection[sportid]) {
            this.state.tournamentselection[sportid] = {};
        }

        if (!this.state.tournamentselection[sportid][categoryid]) {
            this.state.tournamentselection[sportid][categoryid] = [];
        }

        this.state.tournamentselection[sportid][categoryid].push(tournamentid);
        this.setState(this.state);
        this.performOutcomeSearch();
    }

    outcomeSelectionToggle(outcomeid) {
        if (this.state.outcomeselection.indexOf(outcomeid) !== -1) {
            this.state.outcomeselection = this.state.outcomeselection.filter(oid => oid !== outcomeid);
            this.setState(this.state);
            return;
        }

        this.state.outcomeselection.push(outcomeid);
        this.setState(this.state);
    }

    printOutcomePosition(outcomeid) {
        const position = this.state.outcomeselection.indexOf(outcomeid);

        if (position !== -1) {
            return printOrdinalNumber(position+1);
        }

        return '';
    }

    render() {
        return <div>
			<div class="w-full mt-3">
				<div id="fn-top-filters" class="w-full panel bg-slate-100 text-slate-950 py-2 rounded-lg">
					<form class="flex">
						<SelectRow
							label={<span class="block text-sm"><Trans>Ordinamento</Trans></span>}
							boxclass={"px-2 pb-1 w-44 flex-shrink-0 flex-grow-0"}
							class={"px-2 py-1 rounded border bg-white text-black h-8 w-full"}
							onChange={e => {
								this.state.form.sort = e.currentTarget.value;
								this.setState(this.state);
							}}
						>
							<option value="1" selected={this.state.form.sort === '1'}><Trans>Evento</Trans></option>
							<option value="2" selected={this.state.form.sort === '2'}><Trans>Data</Trans></option>
							<option value="3" selected={this.state.form.sort === '3'}><Trans>Evento + Data</Trans></option>
						</SelectRow>
						<SelectRow
							label={<span class="block text-sm"><Trans>Orientamento Stampa</Trans></span>}
							boxclass={"px-2 pb-1 w-44 flex-shrink-0 flex-grow-0"}
							class={"px-2 py-1 rounded border bg-white text-black h-8 w-full"}
							onChange={e => {
								this.state.form.ori = e.currentTarget.value;
								this.setState(this.state);
							}}
						>
							<option value="L" selected={this.state.form.ori === 'L'}><Trans>Orizzontale</Trans></option>
							<option value="P" selected={this.state.form.ori === 'P'}><Trans>Verticale</Trans></option>
						</SelectRow>
						<DateHelperFilter
							{...this.state.dateFilter}
							class="px-2 py-1 rounded border bg-white text-black h-8"
							onInput={
								(dateFilter) => {
									this.state.dateFilter = dateFilter;
									this.setState(this.state);
								}
							}
						/>
						<SelectRow
							label={<span class="block text-sm"><Trans>Logo</Trans></span>}
							boxclass={"px-2 pb-1 w-44 flex-shrink-0 flex-grow-0"}
							class={"px-2 py-1 rounded border bg-white text-black h-8"}
							onChange={e => {
									this.state.form.logo = !this.state.form.logo;
									this.setState(this.state);
							}}
						>
							<option value={true} selected={this.state.form.logo}><Trans>Con Logo</Trans></option>
							<option value={false} selected={!this.state.form.logo}><Trans>Senza logo</Trans></option>
						</SelectRow>
						<div class="grow"></div>
						<div class="pb-1 flex h-full pt-2 items-end">
							<a href="javascript:void(0);" class="p-2 ml-5 bg-kobaaccent-400 text-black text-base rounded hover:bg-kobaaccent-500" onClick={e => {this.state.outcomeselection = ['3', '152', '75', '149', '89']; this.setState(this.state);}}>
								<Trans>Scegli Principali <i class="fa fa-plus" /></Trans>
							</a>
						</div>
						<div class="pb-1 flex h-full pt-2 pr-2 items-end">
							<a href="javascript:void(0);" class="p-2 ml-5 bg-kobaaccent-400 text-black text-base rounded hover:bg-kobaaccent-500" onClick={e => this.performPDF()}>
								<Trans>Genera PDF <i class="fa fa-search" /></Trans>
							</a>
						</div>
					</form>
				</div>
				<div class="flex items-start justify-start py-2 gap-3">
					<div class="w-full panel bg-slate-100 text-slate-950 rounded-lg overflow-hidden">
						<div class="h-8 bg-kobaaccent-400 text-slate-950 px-2 flex items-center text-sm">
							<div><span class="text-zinc-800 font-bold text-base inline-block w-4 pl-1">1</span> <span class="text-slate-950"><Trans>Scegli Nazione</Trans></span></div>
						</div>
						<ul class="p-3 text-sm">
							{Object.values(this.state.schedules).map(
								sport => <li>
									<div>
										<label class="flex items-center justify-center gap-1">
											<InputFilter
												type="checkbox"
												class=""
												checked={!!this.state.categoryselection[sport._id]}
												onInput={e => this.sportSelectionToggle(sport._id)}
											/>
											<span class={"sporticon grow-0 sp_"+ sport._id +""} />
											<span class="main-text-color inline-block py-1 w-full">{sport.name}</span>
										</label>
									</div>
									<ul class="pl-5 pb-3">
										{Object.values(sport.sub).map(
											category => <li>
												<div>
													<label>
														<InputFilter
															type="checkbox"
															class=""
															checked={!!this.state.categoryselection[sport._id] && this.state.categoryselection[sport._id].indexOf(category._id) !== -1}
															onInput={e => this.categorySelectionToggle(sport._id, category._id)}
														/>
														{/* <span class={"scheduleflag ml-2 flag-" + category.id.split('/')[3]} /> */}
														<span class={"ml-2 inline-block w-4 mr-1 scheduleflag_pos rectangleFlag rectangleFlags_"+ (category.label || category.name).toLowerCase().replace(/ /g, "")} style="vertical-align:text-bottom" />
														<span class="main-text-color inline-block py-1">{category.name}</span>
													</label>
												</div>
											</li>
										)}
									</ul>
								</li>
							)}
						</ul>
					</div>
					<div class="w-full panel bg-slate-100 text-slate-950 rounded-lg overflow-hidden">
						<div class="h-8 bg-kobaaccent-400 text-slate-950 px-2 flex items-center text-sm">
							<div><span class="text-zinc-800 font-bold text-base inline-block w-4 pl-1">2</span> <span class="text-slate-950"><Trans>Scegli Tornei</Trans></span></div>
						</div>
						{!!this.state.loading.tournaments && <p class="main-text-color text-center pt-5">
							<i class="fa text-2xl fa-spin fa-spinner" />
						</p>}
						<ul class="p-3 text-sm">
							{!!Object.values(this.state.tournaments).length && <li>
								<div>
									<label>
										<InputFilter
											type="checkbox"
											class=""
											checked={!!Object.values(this.state.tournamentselection).length}
											onInput={e => this.tournamentAllToggle()}
										/>
										<span class="main-text-color inline-block py-1 px-2"><Trans>Tutti</Trans></span>
									</label>
								</div>
							</li>}
							{!!this.state.tournaments && Object.entries(this.state.tournaments).map(
								([sportid, categories]) => <li>
									<div>
										<label>
											<span class="main-text-color py-1 px-2 flex items-center gap-1">
												<span class={"sporticon grow-0 sp_" + sportid + ""} style="margin:0" />
												<span>{this.state.sportnames[sportid]}</span>
											</span>
										</label>
									</div>
									<ul class="pl-5 pb-3">
										{Object.entries(categories).map(
											([categoryname, tournaments]) => <li>
												<div>
													<label>
														<InputFilter
															type="checkbox"
															class=""
															checked={!!this.state.tournamentselection[sportid] && !!this.state.tournamentselection[sportid][tournaments[0].pal]}
															onInput={e => this.tournamentParentToggle(sportid, tournaments[0].pal, categoryname)}
														/>
														{/* <span class={"scheduleflag ml-2 flag-" + tournaments[0].pal} /> */}

														<span class={"ml-2 scheduleflag_pos inline-block w-4 mr-1 rectangleFlag rectangleFlags_"+ (categoryname).toLowerCase().replace(/ /g, "")} style="vertical-align:text-bottom" />
														<span class="main-text-color inline-block py-1">{categoryname}</span>
													</label>
												</div>
												<ul class="pl-5 pb-1">
													{tournaments.map(
														tournament => <li>
															<label>
																<InputFilter
																	type="checkbox"
																	class=""
																	checked={
																		!!this.state.tournamentselection[sportid]
																		&& !!this.state.tournamentselection[sportid][tournament.pal]
																		&& this.state.tournamentselection[sportid][tournament.pal].indexOf(tournament.num) !== -1
																	}
																	onInput={e => this.tournamentSelectionToggle(sportid, tournament.pal, tournament.num)}
																/>
																{/* <span class={"scheduleflag ml-2 flag-" + tournament.pal} /> */}
																<span class={"ml-2 scheduleflag_pos inline-block w-4 mr-1 rectangleFlag rectangleFlags_"+ (categoryname).toLowerCase().replace(/ /g, "")} style="vertical-align:text-bottom" />
																<span class="main-text-color inline-block py-1">{tournament.name}</span>
															</label>
														</li>
													)}
												</ul>
											</li>
										)}
									</ul>
								</li>
							)}
						</ul>
					</div>
					<div class="w-full panel bg-slate-100 text-slate-950 rounded-lg overflow-hidden">
						<div class="h-8 bg-kobaaccent-400 text-slate-950 px-2 flex items-center text-sm">
							<div><span class="text-zinc-800 font-bold text-base inline-block w-4 pl-1">3</span> <span class="text-slate-950"><Trans>Scegli Mercati</Trans></span></div>
						</div>
						{!!this.state.loading.outcomes && <p class="main-text-color text-center pt-5">
							<i class="fa text-2xl fa-spin fa-spinner" />
						</p>}
						<ul class="p-3 text-xs">
							{!!this.state.outcomes && Object.entries(this.state.outcomes).map(
								([outcomeid, outcomename]) => <li>
									<div>
										<label class="flex items-center justify-start">
											<InputFilter
												type="checkbox"
												class=""
												checked={this.state.outcomeselection.indexOf(outcomeid) !== -1}
												onInput={e => this.outcomeSelectionToggle(outcomeid)}
											/>
											<span class="main-text-color w-full py-1 px-2">
												<span class="main-color inline-block font-bold">{outcomeid}</span>
												<span class="inline-block pl-2">{outcomename}</span>
											</span>
											<span class="text-right font-bold font-mono main-color">{this.printOutcomePosition(outcomeid)}</span>
										</label>
									</div>
								</li>)}
						</ul>
					</div>
				</div>
			</div>
		</div>;
    }
}